import { COLORS } from 'shared/constants/theme';

export default {
  tvGuide: {
    border: '#ddd',
    channel: {
      background: '#ebebeb'
    },
    program: {
      background: '#ebebeb',
      dots: {
        color: '#ccc'
      },
      type: {
        color: '#a3a3a3'
      }
    },
    days: {
      color: {
        default: '#676767',
        active: COLORS.cerulean
      }
    },
    hours: {
      color: COLORS.white,
      background: COLORS.black
    },
    modal: {
      background: COLORS.white,
      subtitle: {
        color: '#a3a3a3'
      }
    },
    verticalBar: {
      color: COLORS.cerulean
    }
  }
};
